module.exports = __webpack_public_path__ + "img/coin5.81474b0.webp";